import styled from 'styled-components';
import COLORS from '../../../common/colors';

export const StyledFooterDiv = styled.div`
  width:100%;
  box-sizing: border-box;
  text-align: right;
  visibility: ${props => props.visibility || 'visible'};
  ${props => (props.isInviteReflow ? `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 22px 14px;;
    @media screen and (max-width: 250px) {
      padding: 10px 2px;
      }
      ` : `
    padding: 22px;
    position: absolute;
    bottom: 0;
    left: 0;
    float: right;
    div {
      display: inline;
    }
  `)}
  .react-hint {
    padding: 5px;
    position: absolute;
    z-index: 9999;
    cursor: default;
    animation: 0.5s fadeIn;
  }
  .react-hint__content {
    display:block;
    width: max-content;
    max-width:200px;
    ${props => props.isInviteReflow ? `
      @media screen and (min-width: ${props.horizontal}px) {
        max-width: calc(${props.horizontal}px - 160px);
      }
      @media screen and (max-width: 420px) {
        max-width: calc(100vw - 60px);
      }
      position: absolute;
      bottom: -0.9375rem;
    ` : ''};
    word-wrap:break-word;
    font-weight:500;
    padding: 8px 3px;
    font-size: ${({ isInviteReflow }) => isInviteReflow ? '0.75rem' : '12px'};
    border-radius: 5px;
    text-align:center;
    background: #000;
    color: #fff;
    ${({ isDirectionRtl }) => isDirectionRtl && 'direction: rtl;'}
  }
  .react-hint:after {
    content: '';
    width: 0;
    height: 0;
    margin: auto;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 5px solid transparent;
  }
  .react-hint--top:after {
    top: auto;
    border-bottom: none;
    border-top-color: #000;
  }
  .react-hint--left {
    direction: rtl;
  }
  .react-hint--left:after {
    border-right: none;
    border-left-color: #000;
    ${props => props.isInviteReflow ? `
      left: 4px;
      bottom: 0;
    ` : `
      left: auto;
    `};
  }

  .react-hint--right:after {
    border-left: none;
    border-right-color: #000;
    ${props => props.isInviteReflow ? `
      right: 4px;
      bottom: 0;
    ` : `
      right: auto;
    `};
  }

  .react-hint--bottom:after {
    bottom: auto;
    border-top: none;
    border-bottom-color: #000;
  }
  .kpl-invitation-tooltip {
    color:${COLORS.TOOLTIP_COLOR};
    border: none;
    background: none;
    cursor: pointer;
    ${({ isInviteReflow, isDirectionRtl }) => isInviteReflow ? `
      width: 1.75rem;
      height: 1.875rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 1px;
      @media screen and (max-width: 250px) {
        width: 1rem;
        height: 1rem;
      }
      &:focus {
        outline: ${COLORS.BLUE_WCAG_BORDER} solid 2px;
        outline-offset: 2px;
      }
      svg {
        min-width: 13.16px;
        min-height: 15px;
        height: 0.8225rem;
        width: 0.9375rem;
      }
      ` : `
      float: ${isDirectionRtl ? 'right' : 'left'};
    `}
  }
`;

export const StyledPoweredByAnchorTag = styled.a`
  float: ${({ isInviteReflow, isDirectionRtl }) => (
    isInviteReflow ? 'none' : isDirectionRtl ? 'left' : 'right')};
  font-size: ${({ isInviteReflow }) => isInviteReflow ? '0.75rem' : '12px'};
  font-weight: 400;
  color: #595959;
  outline: 0;
  text-decoration: none;
  cursor: pointer;
  ${props => (props.isInviteReflow ? `
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    width: fit-content;
    height: 1.7rem;
    align-items: center;
    min-height: 30px;
    border-radius: 1px;
    position: relative;
    @media screen and (max-width: 250px) {
      margin: 0 5px;
    }
  ` : '')}
  &:focus {
    outline: ${COLORS.BLUE_WCAG_BORDER} solid 2px;
    outline-offset: 2px;
  }
  &.wcag-powered-by-contrast {
    color: #393941;
  }
  ${({ isDirectionRtl }) => isDirectionRtl && 'float: left; & img {padding: 0 5px 0 0;}'};
  ${({ isWcagCompatibleLogo }) =>
    isWcagCompatibleLogo && 'font-family: Open Sans'};
`;

export const StyledPoweredByLogoImage = styled.img`
  padding: 0 0 0 5px;
  display: inline;
  height: ${({ isInviteReflow }) => isInviteReflow ? '0.875rem' : '14px'};
  vertical-align: middle;
  border: 0;
`;
